module.exports = __webpack_public_path__ + "static/media/task9Planet2.c55dd765.png";